export const GET_PALLETSWOINVOICE_DATA = "GET_PALLETSWOINVOICE_DATA";
// export const GET_DAILY_DATA = "GET_DAILY_DATA";
// export const GET_SEASON_DATA = "GET_SEASON_DATA";
// export const GET_SUMMARY_DATA = "GET_SUMMARY_DATA";
// export const GET_PLOT_DATA = "GET_PLOT_DATA";

